import React from "react";
import ReactDOM from "react-dom";
import styles from "./StatisticsDetailModal.module.css";
import { MyIcons } from "../icons/my-icons";
import moment from "moment";

const StatisticsDetailModal = ({ 
  isOpen, 
  onClose, 
  data, 
  period, 
  onDownload,
  onDownloadComercial,
  loading 
}) => {
  if (!isOpen) return null;

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(value || 0);
  };

  const getPeriodLabel = (period) => {
    const labels = {
      'hoy': 'Hoy',
      'semana': 'Esta semana',
      'mes': 'Este mes',
      'trimestre': 'Este trimestre',
      'anio': 'Este año'
    };
    return labels[period] || period;
  };

  const getTypeLabel = () => {
    if (!data || !data.type) return '';
    if (data.type === 'expedientes') return 'Expedientes';
    if (data.type === 'citas') return 'Citas';
    return 'Facturación';
  };

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            {getTypeLabel()} - {getPeriodLabel(period)}
          </h2>
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons name="times" />
          </button>
        </div>

        <div className={styles.modalBody}>
          {loading ? (
            <div className={styles.loadingContainer}>
              <div className={styles.spinner}></div>
              <p>Cargando datos...</p>
            </div>
          ) : (
            <>
              {/* Total */}
              <div className={styles.totalSection}>
                <div className={styles.totalLabel}>
                  {data?.type === 'expedientes' && 'Total de Expedientes'}
                  {data?.type === 'citas' && 'Total de Citas'}
                  {data?.type === 'facturado' && 'Total Facturado'}
                </div>
                <div className={styles.totalValue}>
                  {data?.type === 'facturado' 
                    ? formatCurrency(data?.total)
                    : data?.total
                  }
                </div>
              </div>

              {/* Desglose por comerciales */}
              <div className={styles.commercialsSection}>
                <h3 className={styles.sectionTitle}>Desglose por Comerciales</h3>
                {data?.comerciales && data.comerciales.length > 0 ? (
                  <div className={styles.commercialsList}>
                    {data.comerciales.map((comercial, index) => (
                      <div key={index} className={styles.commercialItem}>
                        <div className={styles.commercialInfo}>
                          <span className={styles.commercialName}>
                            {comercial.nombre || 'Sin nombre'}
                          </span>
                          <span className={styles.commercialValue}>
                            {data?.type === 'facturado' 
                              ? formatCurrency(comercial.total)
                              : comercial.total
                            }
                          </span>
                        </div>
                        {onDownloadComercial && data?.type !== 'citas' && (
                          <button
                            className={styles.downloadComercialButton}
                            onClick={() => onDownloadComercial(comercial.nombre)}
                            disabled={loading}
                            title={`Descargar Excel de ${comercial.nombre}`}
                          >
                            <MyIcons name="download" />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={styles.emptyMessage}>
                    No hay datos de comerciales disponibles
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className={styles.modalFooter}>
          {data?.type !== 'citas' && (
            <button 
              className={styles.downloadButton}
              onClick={onDownload}
              disabled={loading}
            >
              <MyIcons name="download" />
              <span>Descargar Todos</span>
            </button>
          )}
          <button 
            className={styles.cancelButton}
            onClick={onClose}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StatisticsDetailModal;
